<template>
  <div>
    <v-expansion-panels tile v-model="panel" multiple>
      <v-expansion-panel>
        <v-expansion-panel-header class="pa-0">
          <!-- <div class="text-subtitle-2 borderLight--text">
            <span class="secondary--text bold"
              ><v-icon class="mr-2" color="secondary">mdi-alert-box</v-icon>Warning:</span
            >
            Transformer might run out of capacity on busy days.
          </div> -->
          <v-row no-gutters class="pa-2 mt-2 mb-3 mx-0 rounded">
            <v-col cols="1">
              <v-icon color="secondary"> mdi-information </v-icon>
            </v-col>
            <v-col cols="11" class="text-subtitle-2 secondary--text bold">
              Transformer might run out of capacity on busy days.
              <div class="borderLight--text">
                Max Annual Load Day: <span class="text-caption borderDark--text">23/12/2023</span>, Max Load:
                <span class="text-caption borderDark--text">187.22 kVA</span>
              </div>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <AreaChartVT
            v-if="power_load_data_only"
            :chartData="power_load_data_only"
            :ylabel="power_model_chart.yAxis"
            :xlabel="power_model_chart.xAxis"
            :colors="power_model_chart.colors"
            :vAxes="power_model_chart.vAxes"
            :series="power_model_chart.series"
            :chart_title="power_load_chart_title"
            lineWidth="1"
            pointSize="1"
            dataOpacity="1"
          ></AreaChartVT>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import AreaChartVT from "../components/AreaChartVT";
export default {
  name: "CapacityAreChart",
  props: {},
  watch: {},
  components: { AreaChartVT },
  data: function () {
    return {
      panel: false,
      power_load_chart_title: "Max Load",
      power_model_chart: {
        id: "power_model_chartdata",
        label: "Transformer Load",
        xAxis: "Hour of Day",
        yAxis: "Load (kVa)",
        colors: ["#a1c7e2", "#e4592c", "#1b428b", "#52a0d2", "#f7af5d"],

        data: [["Timestamp", "Load (kVa)"]],
        vAxes: {
          0: {
            title: "Load (kVa)",
            gridlines: { color: "#325597", count: 3 },
            minorGridlines: { color: "#fff" },
            textStyle: { color: "#a1c7e2", fontSize: 9 },
            viewWindowMode: "pretty",
            viewWindow: {
              min: 0,
              max: 400,
            },
          },
          1: {
            title: "Headroom (kVa)",
            gridlines: { color: "#325597", count: 3 },
            minorGridlines: { color: "#fff" },
            textStyle: { color: "#a1c7e2", fontSize: 9 },
            viewWindowMode: "pretty",
            viewWindow: {
              min: 0,
              max: 400,
            },
            baseline: 400,
          },
        },
        series: {
          1: {
            targetAxisIndex: 1,
            annotations: {
              textStyle: {
                color: "#000",
              },
            },
          },
        },
      },
      power_load_data_only: [
        [
          "Hour Of Day",
          "Total Load",
          "Headroom",
          {
            role: "annotation",
          },
          {
            role: "tooltip",
            type: "string",
            p: {
              html: true,
              role: "tooltip",
            },
          },
        ],
        [0, 82.11, 82.11, null, "Max Load (82.11 kVA, Headroom =317.89 kVA)"],
        [1, 63.25, 63.25, null, "Max Load (63.25 kVA, Headroom =336.75 kVA)"],
        [2, 58.88, 58.88, null, "Max Load (58.88 kVA, Headroom =341.12 kVA)"],
        [3, 53.36, 53.36, null, "Max Load (53.36 kVA, Headroom =346.64 kVA)"],
        [4, 47.15, 47.15, null, "Max Load (47.15 kVA, Headroom =352.85 kVA)"],
        [5, 60.49, 60.49, null, "Max Load (60.49 kVA, Headroom = 339.51 kVA)"],
        [6, 75.44, 75.44, null, "Max Load (75.44 kVA, Headroom =324.56 kVA)"],
        [7, 120.98, 120.98, null, "Max Load (120.98, Headroom =279.02 kVA)"],
        [8, 104.19, 104.19, null, "Max Load (104.19 kVA, Headroom =295.81 kVA)"],
        [9, 112.93, 112.93, null, "Max Load (112.93 kVA, Headroom =287.07 kVA)"],
        [10, 122.36, 122.36, null, "Max Load (122.36 kVA, Headroom =277.64 kVA)"],
        [11, 140.99, 140.99, null, "Max Load (140.99 kVA, Headroom =259.01 kVA)"],
        [12, 135.01, 135.01, null, "Max Load (135.01 kVA, Headroom =264.99 kVA)"],
        [13, 126.5, 126.5, null, "Max Load (126.5 kVA, Headroom =273.5 kVA)"],
        [14, 121.67, 121.67, null, "Max Load (121.67 kVA, Headroom =278.33 kVA)"],
        [15, 123.05, 123.05, null, "Max Load (123.05 kVA, Headroom =276.95 kVA)"],
        [16, 143.29, 143.29, null, "Max Load (143.29 kVA, Headroom =256.71 kVA)"],
        [17, 172.27, 172.27, null, "Max Load (172.27 kVA, Headroom =227.73 kVA)"],
        [
          18,
          187.22,
          187.22,
          "Max Load (187.22 kVA Headroom =212.78 kVa)",
          "Max Load (187.22 kVA, Hea1droom =212.78 kVA)",
        ],
        [19, 175.49, 175.49, null, "Max Load (175.49 kVA, Headroom =224.51 kVA)"],
        [20, 175.95, 175.95, null, "Max Load (175.95 kVA, Headroom =224.05 kVA)"],
        [21, 186.53, 186.53, null, "Max Load (186.53 kVA, Headroom =213.47 kVA)"],
        [22, 151.11, 151.11, null, "Max Load (151.11 kVA, Headroom =248.89 kVA)"],
        [23, 108.1, 108.1, null, "Max Load (108.1 kVA, Headroom =291.9 kVA)"],
      ],
    };
  },
  methods: {},
  created() {},
  computed: {},
};
</script>

<style lang="scss" scoped></style>
